	<template>
		<div class="adminkeyechart">
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">堆叠柱状图</div>
					<div class="result_right">帖子1255篇</div>
				</div>
				<div class="keyword_box">
					<div id="myChart6" style="width: 95%;height:300px;margin-top: 15px;"></div>
				</div>
			</div>
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">趋势-折线图</div>
					<div class="result_right">帖子1255篇</div>
				</div>
				<div class="keyword_box">
					<div id="myChart" style="width: 95%;height:300px;margin-left: 12px;margin-top: 15px;"></div>
				</div>
			</div>
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">趋势-柱状图</div>
					<div class="result_right">帖子1255篇</div>
				</div>
				<div class="keyword_box">
					<div id="myChart1" style="width: 95%;height:300px;margin-left: 12px;margin-top: 15px;"></div>
				</div>
			</div>
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">趋势-饼状图</div>
					<div class="result_right">帖子1255篇</div>
				</div>
				<div class="keyword_box">
					<div id="myChart2" style="width: 95%;height:300px;margin-left: 12px;margin-top: 15px;"></div>
				</div>
			</div>
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">趋势-散点图</div>
					<div class="result_right">帖子1255篇</div>
				</div>
				<div class="keyword_box">
					<div id="myChart3" style="width: 95%;height:300px;margin-left: 12px;margin-top: 15px;"></div>
				</div>
			</div>
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">趋势-雷达图</div>
					<div class="result_right">帖子1255篇</div>
				</div>
				<div class="keyword_box">
					<div id="myChart4" style="width: 95%;height:300px;margin-left: 12px;margin-top: 15px;"></div>
				</div>
			</div>
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">趋势-漏斗图</div>
					<div class="result_right">帖子1255篇</div>
				</div>
				<div class="keyword_box">
					<div id="myChart5" style="width: 95%;height:300px;margin-left: 12px;margin-top: 15px;"></div>
				</div>
			</div>
			
		</div>
	</template>
	<script>
		import admin from '../../api/admin';
		import { mapState } from 'vuex';
		import { Col, Row,Search,Cell } from 'vant';
		export default {
			data () {
				return {
					name:'',
					num:'',
					bbs:''
				}
			},
			computed: {
				...mapState({
					user: state => state.param.user
				})
			},
			mounted() {
				this.drawkeyLine()
			},
			created () {
				this.name = this.$route.params.name
				this.num = this.$route.params.num
				this.bbs = this.$route.params.bbs
			},
			methods: {
				drawkeyLine(){
					// let myChart = this.$echarts.init(document.getElementById('myChart'))
					// let myChart1 = this.$echarts.init(document.getElementById('myChart1'))
					// let myChart2 = this.$echarts.init(document.getElementById('myChart2'))
					// let myChart3 = this.$echarts.init(document.getElementById('myChart3'))
					// let myChart4 = this.$echarts.init(document.getElementById('myChart4'))
					// let myChart5 = this.$echarts.init(document.getElementById('myChart5'))
					// let myChart6 = this.$echarts.init(document.getElementById('myChart6'))
					// var params={
					// }
					// admin.getKeyEchartsList(params).then(res => {
					// 	var data=res.data.data.info.time
					// 	var series= [{
					// 		name: '关联帖子',
					// 		data: res.data.data.info.bbs,
					// 		type: 'line',
					// 		smooth:true,
					// 		areaStyle: {}
					// 	}]
					// 	var series1= [{
					// 		name: '关联帖子',
					// 		data: res.data.data.info.bbs,
					// 		type: 'bar',
					// 		showBackground: true,
					// 		backgroundStyle: {
					// 			color: 'rgba(220, 220, 220, 0.8)'
					// 		},
					// 		smooth:true,
					// 	}]
					// 	myChart.setOption({
					// 		tooltip: {
					// 			trigger: 'axis'
					// 		},

					// 		xAxis: {
					// 			type: 'category',
					// 			boundaryGap: false,
					// 			data: data
					// 		},
					// 		yAxis: {
					// 			type: 'value'
					// 		},
					// 		legend: {
					// 			data:['关联帖子']
					// 		},
					// 		series:series
					// 	});
					// 	myChart1.setOption({
					// 		tooltip: {
					// 			trigger: 'axis'
					// 		},

					// 		xAxis: {
					// 			type: 'category',
					// 			data: data
					// 		},
					// 		yAxis: {
					// 			type: 'value'
					// 		},
					// 		legend: {
					// 			data:['关联帖子']
					// 		},
					// 		series:series1
					// 	});
					// 	myChart2.setOption({
							
					// 		tooltip: {
					// 			trigger: 'item',
					// 			formatter: '{a} <br/>{b} : {c} ({d}%)'
					// 		},
					// 		legend: {
					// 			orient: 'vertical',
					// 			left: 'left',
					// 			data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
					// 		},
					// 		series: [
					// 		{
					// 			name: '访问来源',
					// 			type: 'pie',
					// 			radius: '55%',
					// 			center: ['50%', '60%'],
					// 			data: [
					// 			{value: 335, name: '直接访问'},
					// 			{value: 310, name: '邮件营销'},
					// 			{value: 234, name: '联盟广告'},
					// 			{value: 135, name: '视频广告'},
					// 			{value: 1548, name: '搜索引擎'}
					// 			],
					// 			emphasis: {
					// 				itemStyle: {
					// 					shadowBlur: 10,
					// 					shadowOffsetX: 0,
					// 					shadowColor: 'rgba(0, 0, 0, 0.5)'
					// 				}
					// 			}
					// 		}
					// 		]
					// 	});
					// 	myChart3.setOption({
					// 		tooltip: {
					// 			trigger: 'axis'
					// 		},

					// 		xAxis: {},
					// 		yAxis: {},
					// 		legend: {
					// 			data:['关联帖子']
					// 		},
					// 		series:[{
					// 			symbolSize: 20,
					// 			data: [
					// 			[10.0, 8.04],
					// 			[8.07, 6.95],
					// 			[13.0, 7.58],
					// 			[9.05, 8.81],
					// 			[11.0, 8.33],
					// 			[14.0, 7.66],
					// 			[13.4, 6.81],
					// 			[10.0, 6.33],
					// 			[14.0, 8.96],
					// 			[12.5, 6.82],
					// 			[9.15, 7.20],
					// 			[11.5, 7.20],
					// 			[3.03, 4.23],
					// 			[12.2, 7.83],
					// 			[2.02, 4.47],
					// 			[1.05, 3.33],
					// 			[4.05, 4.96],
					// 			[6.03, 7.24],
					// 			[12.0, 6.26],
					// 			[12.0, 8.84],
					// 			[7.08, 5.82],
					// 			[5.02, 5.68]
					// 			],
					// 			type: 'scatter'
					// 		}]
					// 	});
					// 	myChart4.setOption({
							
					// 		tooltip: {},
					// 		// legend: {
					// 		// 	data: ['预算分配（Allocated Budget）', '实际开销（Actual Spending）']
					// 		// },
					// 		radar: {
					// 			// shape: 'circle',
					// 			name: {
					// 				textStyle: {
					// 					color: '#fff',
					// 					backgroundColor: '#999',
					// 					borderRadius: 3,
					// 					padding: [3, 5]
					// 				}
					// 			},
					// 			indicator: [
					// 			{ name: '凌志', max: 6500},
					// 			{ name: '富士', max: 16000},
					// 			{ name: 'VTEC', max: 30000},
					// 			{ name: '汽车时间', max: 38000},
					// 			{ name: '波子', max: 52000},
					// 			{ name: '其他', max: 25000}
					// 			]
					// 		},
					// 		series: [{
					// 			name: '帖子',
					// 			type: 'radar',
					// 			areaStyle: {normal: {}},
					// 			data: [
					// 			// {
					// 			// 	value: [4300, 10000, 28000, 35000, 50000, 19000],
					// 			// 	name: '评论'
					// 			// },
					// 			{
					// 				value: [5000, 14000, 28000, 31000, 42000, 21000],
					// 				name: '帖子'
					// 			}
					// 			]
					// 		}]
					// 	});
					// 	myChart5.setOption({
							
							
					// 		tooltip: {
					// 			trigger: 'item',
					// 			formatter: "{a} <br/>{b} : {c}%"
					// 		},
							
					// 		legend: {
					// 			data: ['展现','点击','访问','咨询','订单']
					// 		},

					// 		series: [
					// 		{
					// 			name:'帖子数',
					// 			type:'funnel',
					// 			left: '10%',
					// 			top: 60,
					// 			bottom: 60,
					// 			width: '80%',
					// 			min: 0,
					// 			max: 100,
					// 			minSize: '0%',
					// 			maxSize: '100%',
					// 			sort: 'descending',
					// 			gap: 2,
					// 			label: {
					// 				show: true,
					// 				position: 'inside'
					// 			},
					// 			labelLine: {
					// 				length: 10,
					// 				lineStyle: {
					// 					width: 1,
					// 					type: 'solid'
					// 				}
					// 			},
					// 			itemStyle: {
					// 				borderColor: '#fff',
					// 				borderWidth: 1
					// 			},
					// 			emphasis: {
					// 				label: {
					// 					fontSize: 20
					// 				}
					// 			},
					// 			data: [
					// 			{value: 60, name: '访问'},
					// 			{value: 40, name: '咨询'},
					// 			{value: 20, name: '订单'},
					// 			{value: 80, name: '点击'},
					// 			{value: 100, name: '展现'}
					// 			]
					// 		}
					// 		]
					// 	});
					// 	myChart6.setOption({
					// 		tooltip: {
					// 			trigger: 'axis',
					// 			axisPointer: {            
					// 				type: 'shadow'        
					// 			}
					// 		},
					// 		legend: {
					// 			data: [ '帖子数', '评论数']
					// 		},
					// 		grid: {
					// 			left: '3%',
					// 			right: '4%',
					// 			bottom: '3%',
					// 			containLabel: true
					// 		},
					// 		xAxis: [
					// 		{
					// 			type: 'category',
					// 			data: ['ES', 'IS', 'LS', 'ES', 'RX', 'UX', 'CT', 'LF', 'LC', 'SC', 'NX', 'GX', 'LM', 'LX', '新能源LC'],
					// 			axisLabel: {  
					// 				interval:0,
					// 				formatter:function(value)  
					// 				{  
					// 					return value.split("").join("\n");  
					// 				} 
					// 			}
					// 		}
					// 		],
					// 		yAxis: [
					// 		{
					// 			type: 'value'
					// 		},
							
					// 		],
					// 		series: [

					// 		{
					// 			name: '帖子数',
					// 			type: 'bar',
					// 			stack: '广告',
					// 			emphasis: {
					// 				focus: 'series'
					// 			},
					// 			itemStyle: {
					// 				color: '#434644'
					// 			},
					// 			data: [80, 40, 30, 70, 25, 60, 55, 40, 85, 60, 70, 30, 80, 40, 50]
					// 		},
					// 		{
					// 			name: '评论数',
					// 			type: 'bar',
					// 			stack: '广告',
					// 			emphasis: {
					// 				focus: 'series'
					// 			},
					// 			itemStyle: {
					// 				color: '#B9C0C2'
					// 			},
					// 			data: [70, 30, 50, 100, 50, 90, 90, 100, 40, 60, 90, 50, 70, 60, 30]
					// 		}

					// 		]
					// 	});

					// })
}
},
components: {
	[Col.name]: Col,
	[Row.name]: Row,
	[Search.name]:Search,
	[Cell.name]:Cell
}
}
</script>
<style lang="scss">
	.adminkeyechart{
		padding: 15px;
		.result_box{
			font-size: 12px;
			padding:15px;
			margin-top: 15px;
			border:1px solid #BBBBBB;
			border-radius:4px;
			.keyword_box{
				border: 1px solid #BBBBBB;
				border-radius: 4px;
				font-size:12px;
			}
			.result_box_title{
				display: flex;
				align-items:center;
				border-bottom:1px solid #EEEEEE;
				padding:0 10px 10px 10px;
				margin-bottom: 10px;
			}
			.result_text{
				display: flex;
				align-items:center;
				padding:10px 10px;
			}
			.result_text_active{
				background-color:#F8F8F8;
			}
			.result_left{
				flex: 1;
			}
			.result_right{
				float: right;
			}
			.result_bbstit{
				color: #333333;
				font-size: 12px;
				text-decoration:underline;
				border-bottom:1px solid #EEEEEE;
				padding-bottom:10px;
			}
			.result_title_bage{
				width: 36px;
				height: 16px;
				vertical-align:middle;
				margin-left: 10px;
			}
			.result_bbstime{
				color: #999999;
				font-size: 12px;
				padding-top:10px;
				display: flex;
				align-items:center;
			}
		}

	}
</style>
